import React, { useEffect, useState } from "react";
import { 
    AiOutlineArrowLeft,
    AiOutlineInfoCircle,
    AiOutlineSetting,
    AiOutlineRise,
    AiOutlineFall,
    AiOutlinePlayCircle,
    AiOutlineWarning,
    AiOutlineReload,
    AiOutlineClockCircle,
 } from "react-icons/ai";
import { FaRegStopCircle } from "react-icons/fa";
import { 
    DefaultButton, 
    PrimaryButton,
    SearchBox,
 } from "@fluentui/react";
import './nomination.css';
import CriticalMeasureGauge from "../tank/CriticalMeasureGauge";
import TankHistoricalChart from "../tank/TankHistoricalChart";

const NominationPage = ({data, onBack}:any) => {
    const [isRise, setIsRise] = useState(true);

    const criticalMeasureFields = [
        { key: 'level', maxValue: 100, minValue: 0, suffix: 'FT' },
        { key: 'temperature', maxValue: 200, minValue: 0, suffix: '&#8457;' },
        { key: 'flow', maxValue: 4000, minValue: 0, suffix: 'PBH' },
        { key: 'pressure', maxValue: 2, minValue: -2, suffix: "WC''" },
    ];
    const dummy = {
        "tank": "Tank 125",
        "mode": "Idle",
        "status": "Out of Service",
        "alarm": "Leak Detect",
        "customer": "KRATON CHEMICAL, LLC",
        "product": "Sylvapine ACS",
        "available": 3202.82528125,
        "criticalMeasurements": {
            "level": {
                "displayName": "LIT-125-01",
                "fieldName": "LIT-0125-0001",
                "processValue": 63.797000885009766,
                "setPoint": 50.0,
                "hihiAlarm": {
                    "setPoint": 66.6240005493164,
                },
                "hiAlarm": {
                    "setPoint": 65.58499908447266
                },
                "loAlarm": {},
                "loloAlarm": {},
                "valueMin": 0.0,
                "valueMax": 67.5
            },
            "temperature": {
                "displayName": "TIT-125-03",
                "fieldName": "TIT-0125-0003",
                "processValue": 83.98999786376953,
                "setPoint": 50.0,
                "hihiAlarm": {
                    "setPoint": 90.0
                },
                "hiAlarm": {
                    "setPoint": 85.0
                },
                "loAlarm": {
                    "setPoint": 36.0
                },
                "loloAlarm": {
                    "setPoint": 32.0
                },
                "valueMin": 0.0,
                "valueMax": 150.0
            },
            "flow": {
                "displayName": "FIT-125-RATE",
                "fieldName": "FIT-0125-RATE",
                "processValue": 0.479,
                "setPoint": 0.0,
                "hihiAlarm": {},
                "hiAlarm": {},
                "loAlarm": {},
                "loloAlarm": {},
                "valueMin": 0.0,
                "valueMax": 4000.0
            },
            "pressure": {
                "displayName": "PIT-125-01",
                "fieldName": "PIT-0125-0001",
                "processValue": 9.219797134399414,
                "setPoint": 50.0,
                "hihiAlarm": {
                    "setPoint": 37.0
                },
                "hiAlarm": {
                    "setPoint": 35.0
                },
                "loAlarm": {
                    "setPoint": 5.0
                },
                "loloAlarm": {
                    "setPoint": -1.0
                },
                "valueMin": -10.0,
                "valueMax": 90.0
            }
        },
        "nominationDetails": {
            "nominationId": "",
            "nominationNr": "OTH-2024-013757",
            "nominationIt": "0000000010",
            "nominationSt": "1",
            "customerName": "KRATON CHEMICAL, LLC",
            "customerPo": "80536934",
            "productName": "Sylvapine ACS",
            "poundsPerGallon": "",
            "sloc": "",
            "activity": "",
            "direction": "STATIC",
            "promiseDate": "2024-08-05T06:57:56.0198649+00:00",
            "requestedQty": 45000.0,
            "minimumQty": 44325.0,
            "maximumQty": 45675.0,
            "loadingStation": "",
            "created": "2024-07-16T18:46:40",
            "updated": "2024-08-01T23:47:38"
        }
    };
    const { tank, criticalMeasurements, valves, pumps, alarm, orderDetails, transferDetails, ...tankDetails }: any = dummy;
    const chartData = {
        level: [
            { timeNo: '2024-08-05T00:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-05T01:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-05T02:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-05T03:00:00.0000000Z', value: 16.8 },
            { timeNo: '2024-08-05T04:00:00.0000000Z', value: 16.8 },
            { timeNo: '2024-08-05T05:00:00.0000000Z', value: 16.8 },
            { timeNo: '2024-08-05T06:00:00.0000000Z', value: 16.8 },
            { timeNo: '2024-08-05T07:00:00.0000000Z', value: 16.8 },
            { timeNo: '2024-08-05T08:00:00.0000000Z', value: 16.8 },
            { timeNo: '2024-08-05T09:00:00.0000000Z', value: 16.8 },
            { timeNo: '2024-08-05T10:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-05T11:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-05T12:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-05T13:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-05T14:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-05T15:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-05T16:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-05T17:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-05T18:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-05T19:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-05T20:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-05T21:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-05T22:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-05T23:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T00:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T01:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T02:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T03:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T04:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T05:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T06:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T07:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T08:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T09:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T10:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T11:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T12:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T13:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T14:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T15:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T16:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T17:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T18:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T19:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T20:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T21:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T22:00:00.0000000Z', value: 16.79 },
        ],
        temperature: [
            { timeNo: '2024-08-05T00:00:00.0000000Z', value: 83.98 },
            { timeNo: '2024-08-05T01:00:00.0000000Z', value: 83.99 },
            { timeNo: '2024-08-05T02:00:00.0000000Z', value: 83.99 },
            { timeNo: '2024-08-05T03:00:00.0000000Z', value: 83.99 },
            { timeNo: '2024-08-05T04:00:00.0000000Z', value: 83.99 },
            { timeNo: '2024-08-05T05:00:00.0000000Z', value: 83.98 },
            { timeNo: '2024-08-05T06:00:00.0000000Z', value: 83.98 },
            { timeNo: '2024-08-05T07:00:00.0000000Z', value: 83.98 },
            { timeNo: '2024-08-05T08:00:00.0000000Z', value: 83.96 },
            { timeNo: '2024-08-05T09:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-05T10:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-05T11:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-05T12:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-05T13:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-05T14:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-05T15:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-05T16:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-05T17:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-05T18:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-05T19:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-05T20:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-05T21:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-05T22:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-05T23:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T00:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T01:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T02:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T03:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T04:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T05:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T06:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T07:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T08:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T09:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T10:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T11:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T12:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T13:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T14:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T15:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T16:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T17:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T18:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T19:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T20:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T21:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T22:00:00.0000000Z', value: 83.95 },
        ],
        flow: [
            { timeNo: '2024-08-05T00:00:00.0000000Z', value: 1.3 },
            { timeNo: '2024-08-05T01:00:00.0000000Z', value: 1.24 },
            { timeNo: '2024-08-05T02:00:00.0000000Z', value: 1.29 },
            { timeNo: '2024-08-05T03:00:00.0000000Z', value: 1.4 },
            { timeNo: '2024-08-05T04:00:00.0000000Z', value: 1.18 },
            { timeNo: '2024-08-05T05:00:00.0000000Z', value: 1.03 },
            { timeNo: '2024-08-05T06:00:00.0000000Z', value: 1.35 },
            { timeNo: '2024-08-05T07:00:00.0000000Z', value: 1.55 },
            { timeNo: '2024-08-05T08:00:00.0000000Z', value: 2.5 },
            { timeNo: '2024-08-05T09:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-05T10:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-05T11:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-05T12:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-05T13:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-05T14:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-05T15:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-05T16:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-05T17:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-05T18:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-05T19:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-05T20:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-05T21:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-05T22:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-05T23:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T00:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T01:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T02:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T03:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T04:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T05:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T06:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T07:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T08:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T09:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T10:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T11:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T12:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T13:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T14:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T15:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T16:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T17:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T18:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T19:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T20:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T21:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T22:00:00.0000000Z', value: 3.29 },
        ],
        pressure: [
            { timeNo: '2024-08-05T00:00:00.0000000Z', value: 10.27 },
            { timeNo: '2024-08-05T01:00:00.0000000Z', value: 9.52 },
            { timeNo: '2024-08-05T02:00:00.0000000Z', value: 9.08 },
            { timeNo: '2024-08-05T03:00:00.0000000Z', value: 9.19 },
            { timeNo: '2024-08-05T04:00:00.0000000Z', value: 9.18 },
            { timeNo: '2024-08-05T05:00:00.0000000Z', value: 8.75 },
            { timeNo: '2024-08-05T06:00:00.0000000Z', value: 8.3 },
            { timeNo: '2024-08-05T07:00:00.0000000Z', value: 8.05 },
            { timeNo: '2024-08-05T08:00:00.0000000Z', value: 9.43 },
            { timeNo: '2024-08-05T09:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-05T10:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-05T11:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-05T12:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-05T13:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-05T14:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-05T15:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-05T16:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-05T17:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-05T18:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-05T19:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-05T20:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-05T21:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-05T22:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-05T23:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T00:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T01:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T02:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T03:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T04:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T05:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T06:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T07:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T08:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T09:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T10:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T11:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T12:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T13:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T14:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T15:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T16:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T17:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T18:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T19:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T20:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T21:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T22:00:00.0000000Z', value: 10.94 },
        ],
        volume: [
            { timeNo: '2024-08-05T00:00:00.0000000Z', value: 10.27 },
            { timeNo: '2024-08-05T01:00:00.0000000Z', value: 9.52 },
            { timeNo: '2024-08-05T02:00:00.0000000Z', value: 9.08 },
        ],
        weight: [
            { timeNo: '2024-08-05T01:00:00.0000000Z', value: 9.52 },
            { timeNo: '2024-08-05T00:00:00.0000000Z', value: 10.27 },
            { timeNo: '2024-08-05T02:00:00.0000000Z', value: 9.08 },
        ],
    };
    return (
        <div className="nomination-page">
            <div className="header">
                <div className="left">
                    <DefaultButton className="btn" onClick={()=>onBack(null)}><AiOutlineArrowLeft/></DefaultButton>
                    <h2 className="name">{data?.name} - {data?.chemical}</h2>
                </div>
                <div className="right">
                    <DefaultButton className="btn-dark" style={{border:"1px solid #262626"}}><AiOutlineInfoCircle style={{marginRight:5}}/> Nomination Details</DefaultButton>
                    <DefaultButton className="btn"><AiOutlineSetting/></DefaultButton>
                </div>
            </div>
            <div className="card-row">
                <div className="card">
                    <div className="header">
                        <DefaultButton className="mini-btn" onClick={()=>setIsRise(!isRise)}>{isRise?<AiOutlineRise/>:<AiOutlineFall/>}</DefaultButton>
                        <span>
                        Flow Direction <PrimaryButton className="mini-primary-btn"><FaRegStopCircle style={{marginRight:5}}/>Static</PrimaryButton>
                        </span>
                    </div>
                    <img alt={`Tank Level ${((data?.criticalMeasurements.level.processValue / data?.criticalMeasurements.level.valueMax) * 10).toFixed(0)}`} src={`tank-levels/tank-level-${((data?.criticalMeasurements.level.processValue / data?.criticalMeasurements.level.valueMax) * 10).toFixed(0) }.svg`} />
                    <div className="warning"><AiOutlineWarning style={{marginRight:5}}/>Leak Detected</div>
                </div>
                <div className="card">
                    <p className="title">Tank Details</p>
                    <div className="detail">
                        <p className="key">Customer</p>
                        <p className="val">{data?.brand}</p>
                    </div>
                    <div className="detail">
                        <p className="key">Chemical</p>
                        <p className="val">{data?.chemical}</p>
                    </div>
                    <div className="detail">
                        <p className="key">Available</p>
                        <p className="val">1323.74 <span style={{fontWeight:400}}>metric tons</span></p>
                    </div>
                    <div className="detail">
                        <p className="key">Tank Mode</p>
                        {data?.mode==="ACTIVE"?(
                            <div className="green"><AiOutlineReload style={{marginRight:5}}/>In Service</div>
                        ):(
                            <div className="yellow"><AiOutlineClockCircle style={{marginRight:5}}/> Idle</div>
                        )}
                    </div>
                    <div className="detail">
                        <p className="key">Tank Status</p>
                        {data?.mode==="ACTIVE"?(
                            <div className="green"><AiOutlineReload style={{marginRight:5}}/>In Service</div>
                        ):(
                            <div className="yellow"><AiOutlineClockCircle style={{marginRight:5}}/> Idle</div>
                        )}
                    </div>
                </div>
                <div className="card">
                    <p className="title">Critical Measurements</p>
                    {criticalMeasureFields?.map(({ key, ...rest }:any) => (
                        <CriticalMeasureGauge key={key} {...criticalMeasurements[key]} iconLabel={key} {...rest} />
                    ))}
                </div>
            </div>
            <div style={{marginTop:24}}>
                <TankHistoricalChart {...{ data: chartData }} />
            </div>
        </div>
    )
}

export default NominationPage;